import { createStore } from 'vuex'
import axios from 'axios'  // 只导入需要的axios

export default createStore({
  state: {
    user: null,
    loading: false,
    error: null
  },
  mutations: {
    setUser(state, user) {
      state.user = user
    },
    setLoading(state, loading) {
      state.loading = loading
    },
    setError(state, error) {
      state.error = error
    },
    clearError(state) {
      state.error = null
    }
  },
  actions: {
    login({ commit }, userData) {
      commit('setLoading', true)
      commit('clearError')
      return new Promise((resolve, reject) => {
        axios.post('/auth-service/api/auth/login', userData)
          .then(response => {
            const data = response.data.data || response.data;
            
            if (!data.accessToken) {
              throw new Error('登录响应中未包含token')
            }
            
            const { accessToken, userId, username } = data
            localStorage.setItem('accessToken', accessToken)
            localStorage.setItem('userId', userId)
            localStorage.setItem('username', username)
            commit('setUser', { id: userId, username })
            resolve(data)
          })
          .catch(error => {
            const errorMsg = error.response?.data?.message || 
                           error.message || 
                           '登录失败，请检查用户名和密码'
            commit('setError', errorMsg)
            reject(error)
          })
          .finally(() => {
            commit('setLoading', false)
          })
      })
    },
    logout({ commit }) {
      const token = localStorage.getItem('accessToken')
      const userId = localStorage.getItem('userId')
      return new Promise((resolve) => {
        axios.post('/auth-service/api/auth/logout', null, {
          params: { token, userId }
        }).catch(error => {
          console.error('登出请求失败:', error)
        }).finally(() => {
          localStorage.removeItem('accessToken')
          localStorage.removeItem('userId')
          localStorage.removeItem('username')
          commit('setUser', null)
          resolve()
        })
      })
    },
    fetchUserInfo({ commit }) {
      commit('setLoading', true)
      return new Promise((resolve, reject) => {
        const id = localStorage.getItem('userId')
        if (!id) {
          commit('setError', '未找到用户信息')
          commit('setLoading', false)
          reject(new Error('未找到用户信息'))
          return
        }
        
        axios.get('/user-service/api/v1/users/getById', {
          params: { id }
        })
          .then(response => {
            const userData = response.data.data || response.data
            commit('setUser', userData)
            resolve(userData)
          })
          .catch(error => {
            const errorMsg = error.response?.data?.message || '获取用户信息失败'
            commit('setError', errorMsg)
            reject(error)
          })
          .finally(() => {
            commit('setLoading', false)
          })
      })
    }
  },
  getters: {
    isAuthenticated: state => !!state.user
  }
})
